<div>
    <button pButton type="button" label="Back to Inbox" [routerLink]="['../../../../', 'message-center']"
    ></button>
</div>

<div class="row" *ngIf="response.success!=null && response.success==true">
    <div class="col-sm-12">
        <div class="card-box">
            <div class="mailview-content">
                <div class="mailview-header">
                    <div class="row">
                        <div class="col-sm-9">
                            <div class="text-ellipsis m-b-10">
                                <span class="mail-view-title"> {{message.subject}}</span>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="col-sm-3">
                            <div class="mail-view-action">
                                <span class="p-buttonset">
                                    <!--attach ngifs-->
                                    <!-- <i class="pi pi-flag" style="font-size: 1.7rem" ></i>
                                    <button pButton pRipple label="Reply" *ngIf="query.sent==false"  icon="pi pi-reply" class="p-button-info"></button>
                                    <button pButton pRipple label="Delete" *ngIf="query.sent==false" icon="pi pi-trash" class="p-button-danger"></button> -->
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="sender-info">

                        <div class="receiver-details float-left p-mb-2">
                            <span class="sender-name" *ngIf="query.sent==false">From : <b>{{message.from}}</b></span>
                            <span class="sender-name" *ngIf="query.sent==true">To : <b>{{message.to}}</b></span>


                        </div>
                        <div class="receiver-details float-left">
                            <span class="sender-name">Date : <b>{{message.date | date:'medium'}}</b></span>

                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                <div class="mailview-inner">
                    <pre style="font-family: inherit;" class="WordWrap format-lines"> {{message.message}}</pre>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching your message...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6"></p-progressSpinner>
